/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diag-lab-inventory.reducer';

export const DiagLabInventoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diagLabInventoryEntity = useAppSelector(state => state.diagLabInventory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diagLabInventoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diagLabInventory.detail.title">DiagLabInventory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.id">Id</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.id}</dd>
          <dt>
            <span id="brandId">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.brandId">Brand Id</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.brandId}</dd>
          <dt>
            <span id="batchNumber">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.batchNumber">Batch Number</Translate>
            </span>
            <UncontrolledTooltip target="batchNumber">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.help.batchNumber" />
            </UncontrolledTooltip>
          </dt>
          <dd>{diagLabInventoryEntity.batchNumber}</dd>
          <dt>
            <span id="serialNumber">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.serialNumber">Serial Number</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.serialNumber}</dd>
          <dt>
            <span id="stockQty">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.stockQty">Stock Qty</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.stockQty}</dd>
          <dt>
            <span id="manufacDate">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.manufacDate">Manufac Date</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.manufacDate}</dd>
          <dt>
            <span id="expDate">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.expDate">Exp Date</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.expDate}</dd>
          <dt>
            <span id="taxCode">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.taxCode">Tax Code</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.taxCode}</dd>
          <dt>
            <span id="mrp">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.mrp">Mrp</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.mrp}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.price">Price</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.price}</dd>
          <dt>
            <span id="remainingQuantity">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.remainingQuantity">Remaining Quantity</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.remainingQuantity}</dd>
          <dt>
            <span id="avgUsesPerItem">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.avgUsesPerItem">Avg Uses Per Item</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.avgUsesPerItem}</dd>
          <dt>
            <span id="packs">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.packs">Packs</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.packs}</dd>
          <dt>
            <span id="HSNCode">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.HSNCode">HSN Code</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.HSNCode}</dd>
          <dt>
            <span id="rack">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.rack">Rack</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.rack}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.discount}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.active">Active</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLabInventory.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{diagLabInventoryEntity.diagLab ? diagLabInventoryEntity.diagLab.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLabInventory.type">Type</Translate>
          </dt>
          <dd>{diagLabInventoryEntity.type ? diagLabInventoryEntity.type.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLabInventory.bill">Bill</Translate>
          </dt>
          <dd>{diagLabInventoryEntity.bill ? diagLabInventoryEntity.bill.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diag-lab-inventory" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diag-lab-inventory/${diagLabInventoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiagLabInventoryDetail;
